document.addEventListener("DOMContentLoaded", function () {
    /**
     * Toggles alternating highlight classes on visible items.
     * @param {Element} list 
     */
    function highlightRows(list) {
        let isEven = false;
        list.querySelectorAll(".fl-item").forEach(item => {
            // Check visibility (offsetParent is non-null if element is rendered)
            if (item.offsetParent !== null) {
                item.classList.toggle("hilite", isEven);
                isEven = !isEven;
            }
        });
    }

    /**
     * Updates visibility of filter options (months, years, topics) based on currently active items.
     * @param {Element} list 
     * @param {NodeListOf<Element>} items 
     * @param {string} optionClass 
     * @param {string} dataKey 
     * @param {boolean} shouldUpdate 
     */
    function updateFilterOptions(list, items, optionClass, dataKey, shouldUpdate) {
        const options = list.querySelectorAll(`.${optionClass}`);
        options.forEach(opt => opt.style.display = "");

        if (!shouldUpdate) return;

        // Collect distinct data attributes from currently visible items
        const visibleValues = new Set();
        items.forEach(item => {
            if (item.offsetParent !== null && item.dataset[dataKey]) {
                visibleValues.add(item.dataset[dataKey]);
            }
        });

        // Hide options that have no matching visible items
        options.forEach(opt => {
            const val = opt.dataset[dataKey];
            if (!visibleValues.has(val)) {
                opt.style.display = "none";
                const input = opt.querySelector("input");
                if (input) input.checked = false;
            }
        });
    }

    /**
     * Main filtering function for a given .filterlist container.
     * @param {Element} list 
     */
    function filterList(list) {
        const flItems = list.querySelectorAll(".fl-item");

        // Reset item visibility
        flItems.forEach(item => item.style.display = "");

        // Helper to collect checked values for a given input name
        const getCheckedValues = (name) => {
            return Array.from(list.querySelectorAll(`input[name='${name}']:checked`)).map(cb => cb.value);
        };

        const months = getCheckedValues("month");
        const years = getCheckedValues("year");
        const topics = getCheckedValues("topic");
        const topic2s = getCheckedValues("topic2");

        // Filter items against active criteria
        flItems.forEach(item => {
            const { month, year, topic, topic2 } = item.dataset;
            let show = true;

            if (months.length && !months.includes(month)) show = false;
            if (years.length && !years.includes(year)) show = false;
            if (topics.length && !topics.includes(topic)) show = false;
            if (topic2s.length && !topic2s.includes(topic2)) show = false;

            if (!show) {
                item.style.display = "none";
            }
        });

        // Update dependent checkbox visibility
        const hasTimeFilter = years.length > 0 || months.length > 0;
        const hasTopicFilter = topics.length > 0 || topic2s.length > 0;

        updateFilterOptions(list, flItems, "topicoption", "topic", hasTimeFilter || topic2s.length > 0);
        updateFilterOptions(list, flItems, "topic2option", "topic2", hasTimeFilter || topics.length > 0);
        updateFilterOptions(list, flItems, "monthoption", "month", hasTopicFilter || years.length > 0);
        updateFilterOptions(list, flItems, "yearoption", "year", hasTopicFilter || months.length > 0);

        // Render selected tags pill container
        renderSelections(list, { years, months, topics });

        // Update row striping
        highlightRows(list);
    }

    /**
     * Renders active filter tags and hooks up removal events.
     */
    function renderSelections(list, { years, months, topics }) {
        const selectionsContainer = list.querySelector(".filter-selections");
        if (!selectionsContainer) return;

        selectionsContainer.innerHTML = "";

        const activeFilters = [
            ...years.map(val => ({ type: 'yearoption', key: 'year', val })),
            ...months.map(val => ({ type: 'monthoption', key: 'month', val })),
            ...topics.map(val => ({ type: 'topicoption', key: 'topic', val }))
        ];

        if (activeFilters.length === 0) {
            selectionsContainer.style.setProperty("display", "none", "important");
            return;
        }

        selectionsContainer.style.display = "";

        const closeIconSvg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M504.6 148.5C515.9 134.9 514.1 114.7 500.5 103.4C486.9 92.1 466.7 93.9 455.4 107.5L320 270L184.6 107.5C173.3 93.9 153.1 92.1 139.5 103.4C125.9 114.7 124.1 134.9 135.4 148.5L278.3 320L135.4 491.5C124.1 505.1 125.9 525.3 139.5 536.6C153.1 547.9 173.3 546.1 184.6 532.5L320 370L455.4 532.5C466.7 546.1 486.9 547.9 500.5 536.6C514.1 525.3 515.9 505.1 504.6 491.5L361.7 320L504.6 148.5z" fill="currentColor"/></svg>`;

        activeFilters.forEach(({ type, key, val }) => {
            const pill = document.createElement("div");
            pill.className = "d-flex selection";
            pill.innerHTML = `
                <div>${val}</div>
                <div class="removeselection" data-type="${type}" data-key="${key}" data-val="${val}">
                    <span>${closeIconSvg}</span>
                </div>
            `;
            selectionsContainer.appendChild(pill);
        });
    }

    /* ==========================================================================
       Initialization & Event Delegation
       ========================================================================== */
    document.querySelectorAll(".filterlist").forEach(list => {
        // Run initial highlighting
        highlightRows(list);

        // Delegated listener for checkbox changes
        list.addEventListener("change", (event) => {
            if (event.target.matches("input[name='year'], input[name='month'], input[name='topic'], input[name='topic2']")) {
                filterList(list);
            }
        });

        // Delegated listener for tag removal pill clicks
        list.addEventListener("click", (event) => {
            const removeBtn = event.target.closest(".removeselection");
            if (removeBtn) {
                const { type, key, val } = removeBtn.dataset;
                const targetInput = list.querySelector(`div.${type}[data-${key}='${val}'] input`);
                if (targetInput) {
                    targetInput.checked = false;
                    filterList(list);
                }
            }
        });
    });
});